import axios from "axios";
const baseUrl =
  "https://haste-arcade-voyage.s3.us-east-2.amazonaws.com/voyages/darko/episodes/";

export async function getStory(episode) {
  const res = await axios.get(`${baseUrl}Episode_${String(episode)}.json`);
  return res.data;
}
